
import { Component, Vue, Watch } from 'vue-property-decorator'
import { apiShopGiftConfig, apiEditShopGiftConfig } from '@/api/shop'

@Component({})

export default class shopDisposition extends Vue {
    id: any = 0
    stk: any = 0
    isAdd = ''
    isAddOn = ''
    isHis = ''
    checkedTA: any = '' // 是否转赠
    checkedPoint: any = '' // 是否转积分
    disabled = false // 禁用按钮
    inputValue: any = '' //手续费
    isShow = false // 手续费是否可见
    isAddClick() {
        this.isAdd = this.isAdd === '开启' ? '关闭' : '开启'
        this.isHis = this.isAdd === '关闭' ? '已开启' : '已关闭'
        if (this.isAdd === '开启') {
            this.disabled = true
            this.checkedTA = false
            this.checkedPoint = false
            this.isShow = false
        } else if (this.isAdd === '关闭') {
            this.isShow = true
            this.checkedTA = true
            this.checkedPoint = true
            this.disabled = false
        }
    }

    numValid(inputContent: any) {
        const reg = /^([0-9]|1[0-9]|20)$/
        if(reg.test(inputContent) == false) {
            this.inputValue = ""
        } else { 
            this.inputValue = inputContent
        }
    }

    handlePoint() {
        if(this.checkedPoint === true) {
            this.isShow = true
        } else {
            this.isShow = false
        }
    }
    // 获取商品配置
    getShopGiftConfig() {
        const param = {
            id: this.id,
        }
        apiShopGiftConfig(param, {'stk': this.stk}).then((res: any) => {
            this.isAddOn = res.gift_open
            this.isHis = (res.gift_open == 0 ? '已关闭' : '已开启')
            this.isAdd = (res.gift_open == 0 ? '开启' : '关闭')
            this.checkedTA = (res.gift_transfer_open == 0 ? false : true)
            this.checkedPoint = (res.gift_to_score_open == 0 ? false : true)
            this.isShow = (res.gift_to_score_open == 0 ? false : true)
            this.disabled = (res.gift_open == 0 ? true : false)
            this.inputValue = res.gift_to_score_commission
        })
    }

    // 保存
    handleGiftConfig() {
        const param = {
            id: this.id,
            gift_open: this.isAdd === '开启' ? 0 : 1,
            gift_transfer_open: this.checkedTA === true ? 1 : 0, //转赠他人
            gift_to_score_open: this.checkedPoint === true ? 1 : 0, //积分
            gift_to_score_commission: this.inputValue, //手续费
        }
        apiEditShopGiftConfig(param).then((res: any) => {
            this.$router.go(-1)
        })

    }

    created () {
        this.id = this.$route.query.id
        this.stk = this.$route.query.stk
        this.getShopGiftConfig()
    }

}
